import React from "react";
import Content from "../components/Common/Content";
import Layout from "../components/Common/Layout";
import Main from "../components/Common/Main";
import Section from "../components/Common/Section";
import Title from "../components/Common/Title";
import Spacing from "../constants/Spacing";
import Paragraph from "../components/Common/Paragrpah";
import {
    developerModules,
    devopsModules,
} from "../data/learningPathData";
import Module from "../components/LearningPath/Module";
import Color from "../constants/Color";
import SEO from "../components/Common/SEO";

const LearningPath = () => {
    return (
        <Layout title="LearnCMD Learning Path - Comprehensive Terminal & Command Line Curriculum">
            <SEO 
                title="LearnCMD Learning Path - Comprehensive Terminal & Command Line Curriculum"
                description="Explore our comprehensive learning path for mastering the Linux and Unix terminal. From basic commands to advanced shell scripting, our curriculum covers everything you need to become proficient in command line operations."
                pathname="/learning-path"
            />
            <Main>
                <Section>
                    <Content>
                        <Title
                            marginTop={Spacing.SPACING_3}
                            marginBottom={Spacing.SPACING_3}
                        >
                            Learning Path
                        </Title>
                        <Paragraph marginBottom={Spacing.SPACING_4}>
                            The course is divided into modules, each focused on a single topic. Every module contains a series of lessons. You can take the modules in any order—there's no required sequence.
                        </Paragraph>
                    </Content>
                </Section>
                <Section backgroundColor={Color.BACKGROUND_LIGHT_2}>
                    <Content>
                        <Title
                            marginBottom={Spacing.SPACING_3}
                            marginTop={Spacing.SPACING_4}
                        >
                            Course Modules
                        </Title>
                        {developerModules.map(({ subtitle, text }, index) => {
                            return (
                                <Module
                                    key={index}
                                    subtitle={subtitle}
                                    text={text}
                                />
                            );
                        })}
                    </Content>
                </Section>
                <Section>
                    <Content>
                        <Title
                            marginBottom={Spacing.SPACING_3}
                            marginTop={Spacing.SPACING_4}
                        >
                            Command Line Reference Guides
                        </Title>
                        <Paragraph marginBottom={Spacing.SPACING_4}>
                            Quick reminders for useful flags and principles that
                            are hard to remember.
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        Archives and Compression
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        Bash Basics
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        Basic Network Troubleshooting
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        Basic Shell Navigation
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        Comparing Files in Linux
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        Curl and Wget
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        Environment Variables
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        File Permissions
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                            File Management
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        Getting Help
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        Grep and Regular Expressions (Regex)
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        JSON and YAML Processing Guide
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        Linux Package Management for Multiple Distributions
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        Nano Reference
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        Process Management
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        Redirection and Pipes in Linux
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        SSH, SCP, and RSYNC Guide
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        Shell Features
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        Shell Scripting
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        Signals
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        Tab Completion
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        Terminal Shortcuts Cheatsheet
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        Ubuntu Package Management
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        Understanding the Shell and Terminal
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        Users and Groups
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                        Vim Reference
                        </Paragraph>

                    </Content>
                </Section>
                <Section backgroundColor={Color.BACKGROUND_LIGHT_2}>
                    <Content>
                        <Title
                            marginBottom={Spacing.SPACING_3}
                            marginTop={Spacing.SPACING_4}
                        >
                            Additional Resources
                        </Title>
                        <Paragraph marginBottom={Spacing.SPACING_4}>
                            Here are some interesting articles that will help
                            you expand your knowledge and understanding of
                            Linux. These are not strictly related to the command
                            line interface itself but you might find these
                            topics both useful and fascinating while on the path
                            to mastering the command line.
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                            Comparison of Shells
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_2}>
                            Linux vs MacOS Terminal: A Comprehensive Comparison
                        </Paragraph>
                        <Paragraph marginBottom={Spacing.SPACING_6}>
                            Terminal vs GUI: Understanding the Two Faces of Computing
                        </Paragraph>
                    </Content>
                </Section>
            </Main>
        </Layout>
    );
};

export default LearningPath;
